<template>
  <div class="main-container">
    <div class="ui middle aligned center aligned grid">
      <div class="login-container" style="max-width: 520px;">
        <div class="login-content">
          <h1>Choose an account</h1>
          <p class="light">Select which company you want to access. To switch accounts later, log out and sign in again.</p>

          <app-form-error></app-form-error>

          <div v-if="loading" class="ui active centered inline loader"></div>

          <div v-else class="ui fluid vertical menu">
            <button
              v-for="membership in memberships"
              :key="membership.membership_id"
              type="button"
              class="item account-picker-item"
              :class="{ loading: selectingId === membership.company_id }"
              :disabled="selecting"
              @click="selectCompany(membership.company_id)"
            >
              <div class="account-picker-row">
                <img
                  v-if="membership.logo_url"
                  :src="membership.logo_url"
                  alt=""
                  class="ui avatar image"
                  width="40"
                  height="40"
                >
                <img
                  v-else
                  src="../../assets/img/icn_avatar.png"
                  alt=""
                  class="ui avatar image"
                  width="40"
                  height="40"
                >
                <div class="account-picker-text">
                  <div class="account-picker-name">{{ membership.company_name }}</div>
                  <div class="account-picker-meta" v-if="membership.owner_name">Owner: {{ membership.owner_name }}</div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import auth from '../../helpers/auth'

export default {
  name: 'SelectAccount',
  data () {
    return {
      memberships: [],
      loading: true,
      selecting: false,
      selectingId: null
    }
  },
  created () {
    auth.check(this, false).then(() => {
      this.loadMemberships()
    }).catch(() => {
      this.$router.push('/login')
    })
  },
  methods: {
    loadMemberships () {
      axios.get('/api/auth/memberships').then((res) => {
        this.memberships = Array.isArray(res.data && res.data.memberships) ? res.data.memberships : []
        if (this.memberships.length === 0) {
          this.errorNotification('No accounts found for your login')
          auth.logout(this)
        } else if (this.memberships.length === 1) {
          this.selectCompany(this.memberships[0].company_id)
        }
      }).catch(() => {
        this.errorNotification('Failed to load accounts')
      }).finally(() => {
        this.loading = false
      })
    },
    selectCompany (companyId) {
      this.selecting = true
      this.selectingId = companyId
      axios.post('/api/auth/select-company', { company_id: companyId }).then((res) => {
        if (res.data && res.data.user) {
          this.$store.commit('user/setUserProfile', res.data.user)
        }
        this.$store.commit('user/setPendingAccountSelection', false)
        this.$router.push('/')
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Failed to select account'
        this.errorNotification(msg)
      }).finally(() => {
        this.selecting = false
        this.selectingId = null
      })
    }
  }
}
</script>

<style scoped>
.account-picker-item {
  text-align: left;
  cursor: pointer;
  border: none;
  background: #fff;
}
.account-picker-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.account-picker-text {
  text-align: left;
}
.account-picker-name {
  font-weight: 600;
  color: #323C47;
}
.account-picker-meta {
  font-size: 13px;
  color: #707070;
  margin-top: 2px;
}
</style>
